/**
 * Returns the current CSRF token
 * @return {string} The CSRF token
 */
export function getToken(): string {
	return window.CSRF_TOKEN;
}
